import styled, { css } from 'styled-components';
import { typography } from '@legacy-vfuk/core-mixins';

const lineClamp = (linesQuantity: number) => `
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: ${linesQuantity};
  -webkit-box-orient: vertical;
`;

export const BlockWrapper = styled.div`
  @media (min-width: 768px) {
    min-height: 577px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
  }

  [class^='Blockstyle__Block-sc'] {
    padding: 32px 16px;

    @media (min-width: 768px) {
      padding: 48px 20px 36px 20px;
      width: 100%;
    }

    [class^='Blockstyle__ContentWrapper-sc'] {
      display: flex;
      flex-direction: column;
      max-width: 1280px;
    }
  }
`;

export const whiteCSS = css`
  background-color: var(--white);
`;

export const galleryCSS = css`
  background-color: var(--gallery);
`;

export const ContainerWrapper = styled.div<{ isMediaLeft: boolean }>`
  display: flex;
  flex-direction: ${props => (props.isMediaLeft ? 'row-reverse' : 'row')};

  @media (max-width: 1024px) {
    padding: 0 20px;
    flex-direction: column;
    align-items: center;
  }
`;

export const ContentWrapper = styled.div<{ isMediaLeft: boolean }>`
  display: flex;
  flex: 1;
  flex-direction: column;
  margin-right: ${props => (props.isMediaLeft ? '0px' : '40px')};
  margin-left: ${props => (props.isMediaLeft ? '40px' : '0px')};

  @media (max-width: 794px) {
    margin-right: 0px;
    margin-left: 0px;
  }

  h2 {
    margin-top: 0px !important;
    margin-bottom: 0px !important;
  }

  p {
    margin-top: 24px !important;
  }
`;

export const CaroulselWrapper = styled.div`
  min-width: 680px;
  display: flex;
  flex: 1;
  overflow: hidden;
  align-items: center;

  .slick-slide {
    > div {
      height: 100%;
    }
  }

  [class*='CarouselArrowstyle__CarouselArrow-sc']:first-of-type {
    display: none;
  }

  [class*='CarouselArrowstyle__CarouselArrow-sc']:last-of-type {
    display: none;
  }

  @media (max-width: 1024px) {
    min-width: unset;
    max-width: 100%;
  }
`;

export const TestimonialContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  [class^='Headingstyle__Heading-sc'] {
    text-align: center;
    margin-bottom: 0px;

    p {
      ${lineClamp(3)}
      font-size: 20px !important;
      font-weight: 700 !important;
      line-height: 28px !important;
      margin-bottom: 0px;

      @media (max-width: 794px) {
        font-size: 14px !important;
        line-height: 18px !important;
      }
    }
  }

  [class^='Paragraphstyle__Paragraph-sc'] {
    text-align: center;
    @media (max-width: 794px) {
      ${typography.paragraph(1, true)}
      margin-bottom: 6px;
    }
  }

  [data-component-name='PhotoAvatar'] {
    width: 80px;
    height: 80px;
    margin-bottom: 12px;

    @media (max-width: 794px) {
      width: 60px;
      height: 60px;
    }
  }
`;

export const FeedBackWrapper = styled.div`
  [class^='RichTextstyles__ParsedContentWrapper'] {
    margin-bottom: 1rem;

    @media (max-width: 794px) {
      margin-bottom: 0.5rem;
    }
  }
`;

export const TestimonialContainerWrapper = styled.div`
  min-height: 284px;
  padding: 16px;
  background-color: white;
  flex-grow: 1;
  display: flex;
  justify-content: center;
  border-radius: 8px;
  height: 100%;

  @media (max-width: 794px) {
    min-height: unset;
  }

  span {
    font-weight: 500;
    font-size: 14px;
    line-height: 21px;
  }
`;
